import ImagePreview from './ImagePreview';
import './ImagePreview.scss';

export default ImagePreview;
